import env from 'env';

import { type DNTCaptchaApiResponse, DNTCaptchaRealm } from './types';

const API_VERSION_SUFFIX_PATTERN = /\/api\/v\d+\/?$/i;

const buildUrl = (base: string | undefined, portion: string): string => {
  if (/^https?:\/\//i.test(portion)) {
    return portion;
  }

  const normalizedPortion = portion.startsWith('/') ? portion.slice(1) : portion;

  if (!base) {
    return `/${normalizedPortion}`;
  }

  const normalizedBase = base.endsWith('/') ? base : `${base}/`;

  return new URL(normalizedPortion, normalizedBase).toString();
};

const getCaptchaRequestBaseUrl = (realm: DNTCaptchaRealm): string => {
  if (realm === DNTCaptchaRealm.Security) {
    //esto deberia unificarse como standar en los backend de seguridad por eso se hace esta verificación
    const securityPath = API_VERSION_SUFFIX_PATTERN.test(env.baseUrlSecurityApi ?? '')
      ? 'DNTCaptcha'
      : 'v1/DNTCaptcha';

    return buildUrl(env.baseUrlSecurityApi, securityPath);
  }

  return buildUrl(env.baseUrlApplicationApi, 'DNTCaptcha');
};

const getCaptchaImageBaseUrl = (realm: DNTCaptchaRealm): string | undefined => {
  if (realm === DNTCaptchaRealm.Security) {
    return env.sts?.authority;
  }

  return env.serverApplication;
};

/**
 * Responsable de la construcción de la URL de generación del contenido
 * captcha
 *
 * @param {DNTCaptchaRealm} realm Indica si se trata del entorno de seguridad o aplicación
 * @return {*}  {string} Devuelve la ruta para generación del código captcha
 */
export const getCaptchaRequestUrl = (realm: DNTCaptchaRealm): string => {
  return buildUrl(getCaptchaRequestBaseUrl(realm), 'CreateDNTCaptchaParams');
};

export const mapCaptchaApiResponse = (
  apiResponse: DNTCaptchaApiResponse,
  realm: DNTCaptchaRealm
): DNTCaptchaApiResponse => {
  return {
    ...apiResponse,
    dntCaptchaImgUrl: buildUrl(getCaptchaImageBaseUrl(realm), apiResponse.dntCaptchaImgUrl)
  };
};
